<script setup lang="ts">
import type { AppSimpleTableRow } from './AppSimpleTable.model';

interface AppSimpleTableProps {
  header: string;
  rows: AppSimpleTableRow[];
}

const props = defineProps<AppSimpleTableProps>();
</script>

<template>
  <div class="app-simple-table">
    <div class="header">{{ props.header }}</div>
    <div v-for="(row, index) of rows" :key="index" class="row">
      <div class="left-side">{{ row.leftSide }}</div>
      <div class="right-side">{{ row.rightSide }}</div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '../../styles/_fonts.scss';
.app-simple-table {
  display: flex;
  flex-flow: column;
  gap: var(--spacing-2);

  .header {
    padding: var(--spacing-16) var(--spacing-12);
    @include font-label-l-bold;
    color: var(--color-neutral-70);
    background-color: var(--color-neutral-30);
    border-top-left-radius: var(--border-radius-12);
    border-top-right-radius: var(--border-radius-12);
  }

  .row {
    padding: var(--spacing-16) var(--spacing-12);
    @include font-label-s-light;
    color: var(--color-neutral-70);
    background-color: var(--color-neutral-30);

    display: flex;
    justify-content: space-between;
    gap: var(--spacing-8);

    &:last-of-type {
      border-bottom-left-radius: var(--border-radius-12);
      border-bottom-right-radius: var(--border-radius-12);
    }

    .right-side {
      text-wrap: nowrap;
    }
  }
}
</style>
